"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _moment = _interopRequireDefault(require("moment"));
var _getEmptyFieldValue = _interopRequireDefault(require("../../../helpers/getEmptyFieldValue.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var dateFormatByType = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD hh:mm:ss A'
};
var _default = exports["default"] = function _default(values, fieldTypes, hasMatchedUser) {
  var data = {};
  var dataKeys = Object.keys(values).filter(function (k) {
    return k !== 'formHandle';
  });
  var _iterator = _createForOfIteratorHelper(dataKeys),
    _step;
  try {
    var _loop = function _loop() {
      var key = _step.value;
      var field = (0, _find2["default"])(fieldTypes, function (ft) {
        return ft.reduxFieldHandle === key;
      });
      var value = values[key];
      if (value === undefined || !field || field.type === 'coalesceField') {
        return 1; // continue
      }

      // typeof === 'object' is true for null, so we need to check for it specifically
      if (Array.isArray(value) || value !== null && _typeof(value) === 'object') {
        if (value instanceof Date) {
          var momentDate = (0, _moment["default"])(value.toUTCString());
          var dateFormat = dateFormatByType[field.displaySettings.renderAs];
          data[key] = momentDate.format(dateFormat);
        } else {
          data[key] = JSON.stringify(value);
        }
      } else {
        data[key] = value;
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop()) continue;
    }

    // gather all coalesce fields
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var coalesceFields = (0, _filter2["default"])(fieldTypes, function (f) {
    return f.type === 'coalesceField';
  });
  var newFields = {};
  coalesceFields.forEach(function (cf) {
    var value = values[cf.reduxFieldHandle];
    var hasEmptyValue = value !== (0, _getEmptyFieldValue["default"])((0, _find2["default"])(fieldTypes, function (ft) {
      return ft.reduxFieldHandle === cf.reduxFieldHandle;
    }));

    // if key doesn't exist yet in newFields
    if (!Object.keys(newFields).includes(cf.coalesceKey)) {
      // if value === empty value for field
      if (hasEmptyValue) {
        newFields[cf.coalesceKey] = Array.isArray(value) ? value : [value];
      }
    } else if (hasEmptyValue) {
      var coalesceVal = Array.isArray(value) ? value : [value];
      newFields[cf.coalesceKey] = newFields[cf.coalesceKey].concat(coalesceVal);
    }
  });
  Object.keys(newFields).forEach(function (nf) {
    data[nf] = JSON.stringify((0, _uniq2["default"])(newFields[nf]));
  });
  if (hasMatchedUser && 'username' in data) {
    delete Object.assign(data, {
      user: data.username
    }).username;
  }
  return data;
};